import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer, Wrench } from "lucide-react";
import { logError } from "@/lib/logger";
import { Button } from "@/components/ui/button";

export default function LabelPrint() {
  const { code } = useParams();
  const trackUrl = `${window.location.origin}/rastrear/${code}`;

  useEffect(() => {
    // Give the QR a moment to render then trigger print
    const t = setTimeout(() => {
      try { window.print(); }
      catch (err) { logError("[label-print] window.print failed:", err); }
    }, 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-100 print:bg-white print:min-h-0">
      <style>{`
        @page { size: 62mm 40mm; margin: 0; }
        @media print {
          body { background: white !important; margin: 0; }
          .no-print { display: none !important; }
          .label { border: none !important; box-shadow: none !important; margin: 0 !important; }
        }
      `}</style>

      <div className="no-print p-8 max-w-md mx-auto">
        <div className="text-xs uppercase tracking-widest font-bold text-neutral-500 mb-2">Etiqueta</div>
        <h1 className="font-heading font-black text-3xl">Imprimir etiqueta {code}</h1>
        <p className="mt-2 text-sm text-neutral-600">Configure sua impressora para 62 × 40 mm (ou similar). O diálogo de impressão abre automaticamente.</p>
        <div className="mt-6 flex gap-2">
          <Button onClick={() => window.print()} className="bg-neutral-900 hover:bg-neutral-800" data-testid="label-print"><Printer size={14} className="mr-1.5"/> Imprimir</Button>
          <Button variant="outline" onClick={() => window.close()}>Fechar</Button>
        </div>
      </div>

      <div className="flex justify-center py-8 print:p-0 print:block">
        <div
          className="label bg-white border border-neutral-300 shadow-sm"
          style={{ width: "62mm", height: "40mm", padding: "3mm", boxSizing: "border-box" }}
          data-testid="label-preview"
        >
          <div className="flex h-full items-center gap-3">
            <div className="shrink-0 grid place-items-center bg-white">
              <QRCodeSVG value={trackUrl} size={110} level="M" includeMargin={false} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5">
                <div className="w-4 h-4 bg-neutral-900 text-white grid place-items-center rounded"><Wrench size={9}/></div>
                <div style={{ fontFamily: "Outfit, sans-serif", fontWeight: 900, fontSize: "10pt", letterSpacing: "-0.02em" }}>GTec</div>
              </div>
              <div style={{ fontFamily: "JetBrains Mono, monospace", fontSize: "16pt", fontWeight: 700, marginTop: "1mm", lineHeight: 1 }}>{code}</div>
              <div style={{ fontSize: "6.5pt", color: "#666", marginTop: "1.5mm", lineHeight: 1.15 }}>
                Rastreie em<br/>
                <span style={{ fontFamily: "JetBrains Mono, monospace" }}>{window.location.host}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
